<template>
  <div>
    <el-card
      class="card-container"
      shadow="never"
    >
      <CardHeader
        slot="header"
        title="Tài khoản"
        :total="total"
        :size="'small'"
        :disabled="loading"
        :role-total="roleTotal"
        @create="handleCreate"
        @refresh="handleRefresh"
      />
      <div>
        <CardFilter />
        <CardList
          :data="data"
          :loading="loading"
          @update="handleUpdate"
          @delete="handleDelete"
        />
        <el-row
          type="flex"
          align="middle"
          justify="end"
          class="mt-l"
        >
          <el-pagination
            background
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleChangePageSize"
            @current-change="handleChangePage"
          />
        </el-row>
      </div>
      <DataFormPopup
        v-if="formVisible"
        :item="selectedItem"
        :visible="formVisible"
        :org-info="orgInfo"
        @close="formVisible = false"
        @reload="listData"
      />
    </el-card>
  </div>
</template>

<script>
import CardFilter from "./accounts/CardFilter.vue";
import CardHeader from "./accounts/CardHeader.vue";
import CardList from "./accounts/CardList.vue";
import DataFormPopup from "./accounts/DataForm.vue";

import { notification } from "@/utils/common";
import roleUserServices from "@/services/role-user";

export default {
  name: "Accounts",
  components: {
    CardHeader,
    CardFilter,
    CardList,
    DataFormPopup,
  },
  props: {
    orgInfo: Object,
    roleTotal: Number
  },
  data() {
    return {
      loading: false,
      searchText: "",
      page: 1,
      pageSize: 10,
      total: 0,
      data: [],
      selectedItem: null,
      formVisible: false,
    };
  },
  computed: {
    params() {
      const _params = {
        q: this.searchText,
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "vi",
        sort: "-created",
        filters: {
          organization_id: this.orgInfo.id
        }
      };
      return _params;
    },
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    listData() {
      this.loading = true;
      roleUserServices
        .list(this.params)
        .then((response) => {
          this.data = response.items.map((item, index) => ({
            ...item,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          this.total = response.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        roleUserServices
          .remove(item)
          .then(() => {
            if (this.data.length === 1 && this.page > 1) {
              this.page = this.page - 1;
            }
            this.listData();
            notification(this, "success", "delete", "tài khoản");
          })
          .catch(() => {
            notification(this, "error", "delete", "tài khoản");
          });
      });
    },
    handleSearch() {
      this.page = 1;
      this.listData();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.listData();
    },
    handleChangePage(page) {
      this.page = page;
      this.listData();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.listData();
    },
  },
};
</script>

<style lang="scss"></style>
